import React from 'react';
import '../styles/IndianKatha.css';

const productSpecs = [
  { label: 'Product Name', value: 'Desi Katha' },
  { label: 'Product Composition', value: 'Natural extract obtained from Acacia Catechu heartwood' },
  { label: 'Dangerous Ingredients', value: 'None' },
  { label: 'Available in', value: 'Solid, paste, or powder form with customized packaging options' },
];

const industrialUses = [
  'Used in chewable herbal preparations and traditional Indian herbal preparations',
  'Used as a natural flavouring and confectionery ingredient in food processing',
  'Used in confectionery and mouth-freshener applications',
  'Used in flavoured mouth fresheners and natural oral care products',
  'Used in Ayurvedic and herbal formulations',
  'Used in food processing industries',
];

const medicalUses = [
  'Traditionally used for mouth ulcers',
  'Used in digestive wellness applications',
  'Used in Ayurvedic formulations for sore throat and cough',
  'Used in traditional remedies for diarrhea and piles',
  'Supports anti-inflammatory applications',
  'Has astringent, cooling and digestive properties',
];

function IndianKatha() {
  return (
    <div className="katha-page">

      {/* Banner Image */}
      <div className="katha-banner">
        <img src="/ill.png" alt="Indian Katha Banner" className="katha-banner-img" />
      </div>

      {/* Main Content */}
      <div className="katha-container">
        <div className="katha-left">

          <h2 className="katha-title">
            Desi Katha
          </h2>

          <p className="katha-desc">
            <strong>Desi Katha</strong> is a natural extract obtained from the heartwood of
            Acacia Catechu (Khair). It is widely used in traditional Indian herbal preparations,
            chewable herbal preparations, confectionery and mouth-freshener applications,
            flavoured mouth fresheners, herbal formulations, food processing, and Ayurvedic
            applications. Known for its rich natural color, purity, and traditional medicinal
            value, Desi Katha has been used for centuries in India and other Asian countries.
          </p>

          <p className="katha-desc">
            Katha contains natural catechins, tannins, and antioxidant compounds that provide
            astringent, antimicrobial, and digestive-support properties. As a natural flavouring
            and confectionery ingredient, it is processed hygienically to maintain food-grade
            quality and consistent performance.
          </p>

          <p className="katha-desc">
            At Sachin Kath Industries, Desi Katha is manufactured using modern processing
            systems under strict hygiene and quality standards. Carefully selected raw materials,
            advanced filtration, and controlled drying processes help maintain product
            consistency, safety, and long shelf life.
          </p>

          <h3 className="katha-subtitle">Product Identification &amp; Specifications:</h3>
          <table className="katha-table">
            <tbody>
              {productSpecs.map((s, i) => (
                <tr key={i}>
                  <td className="katha-spec-label">{s.label}</td>
                  <td className="katha-spec-value">{s.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className="katha-subtitle">Industrial Use:</h3>
          <ul className="katha-uses">
            {industrialUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

          <h3 className="katha-subtitle">Medical Use:</h3>
          <ul className="katha-uses">
            {medicalUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}

export default IndianKatha;